export default __webpack_public_path__ + "static/media/credit-card.611c0f70.svg";